<template>
  <div :class="['tabPanel', index === selected ? 'tabPanel--selected' : '']">
    <UtilityScroll :height="scrollHeight">
      <slot />
    </UtilityScroll>
  </div>
</template>

<script>
import UtilityScroll from '@/components/utility/Scroll.vue'

export default {
  components: {
    UtilityScroll
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    selected: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  methods: {
    resize () {
      this.windowWidth = window.innerWidth
    }
  },
  computed: {
    scrollHeight () {
      if (this.windowWidth < 640) {
        return '400px'
      } else if (this.windowWidth < 1200) {
        return '360px'
      }

      return '450px'
    }
  },
  created () {
    window.addEventListener('resize', this.resize)
  },
  unmounted () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.tabPanel {
  @include font('content--md', $white, 0.8);
  background-color: $bg-4;
  border-top: 1px solid rgba($white, 0.1);
  padding: 1rem;
  line-height: 1.5rem;
  min-height: 160px;
  white-space: pre-line;
  display: none;

  @media screen and (min-width: $breakpointLg) {
    min-height: 220px;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.8);
    padding: 1rem;
    line-height: 1.75rem;
  }

  &--selected {
    display: flex;
  }
}

</style>
